import { render, staticRenderFns } from "./epinfomsg.vue?vue&type=template&id=d7a9128a&scoped=true&"
import script from "./epinfomsg.vue?vue&type=script&lang=js&"
export * from "./epinfomsg.vue?vue&type=script&lang=js&"
import style0 from "./epinfomsg.vue?vue&type=style&index=0&id=d7a9128a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a9128a",
  null
  
)

export default component.exports